(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
// for navigation overlay
document.addEventListener('DOMContentLoaded', function() {
  const opener = document.querySelector('[data-navigation="opener"]');
  const closer = document.querySelector('[data-navigation="closer"]');
  const content = document.querySelector('[data-navigation="content"]');
  const body = document.body;
  opener.addEventListener('click', function() {
    if (content) {
      content.classList.add('is-show');
      body.classList.add('no-scroll');
    }
  });
  closer.addEventListener('click', function() {
    if (content) {
      content.classList.remove('is-show');
      body.classList.remove('no-scroll');
    }
  });
});

// for navigation sticky
document.addEventListener("DOMContentLoaded", function () {
  const nav = document.querySelector('[data-effect="sticky"]');
  if (!nav) return;
  let initialTop = nav.getBoundingClientRect().top + window.scrollY;
  function updateInitialTop() {
    initialTop = nav.getBoundingClientRect().top + window.scrollY;
    updateStickyState();
  }
  function updateStickyState() {
    const scrollY = window.scrollY;
    const isMobile = window.innerWidth <= 990;
    if (isMobile) {
      // モバイル時のロジック：最上部からスクロールしたら追加、戻ったら削除
      if (scrollY > 0) {
        nav.classList.add("has-sticky");
      } else {
        nav.classList.remove("has-sticky");
      }
    } else {
      // デスクトップ時のロジック：navの位置を超えたら追加、戻ったら削除
      if (scrollY >= initialTop) {
        nav.classList.add("has-sticky");
      } else {
        nav.classList.remove("has-sticky");
      }
    }
  }
  window.addEventListener("scroll", updateStickyState);
  window.addEventListener("resize", updateInitialTop);
  updateStickyState();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["origin-switchimage"] && !Shopify.designMode) return;
  try {
    
// for switch image
document.addEventListener("DOMContentLoaded", () => {
  const triggers = document.querySelectorAll("[data-switch-trigger]");
  const images = document.querySelectorAll("[data-switch-image]");

  const updateImageVisibility = (activeValue) => {
    images.forEach(img => img.classList.toggle("is-show", img.getAttribute("data-switch-image") === activeValue));
  };

  const setInitialImage = () => {
    requestAnimationFrame(() => {
      const allTriggersPassed = [...triggers].every(t => t.getBoundingClientRect().bottom < 0);
      const initialImage = allTriggersPassed ? images[images.length - 1] : images[0];
      updateImageVisibility(initialImage?.getAttribute("data-switch-image"));
    });
  };

  window.addEventListener("load", setInitialImage);

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        updateImageVisibility(entry.target.getAttribute("data-switch-trigger"));
      }
    });
  }, { threshold: 0.5 });

  triggers.forEach(el => observer.observe(el));
});

  } catch(e) { console.error(e); }
})();
})();
